import Vue from 'vue'
import Router from 'vue-router'
import Web from './modules/web'
Vue.use(Router)
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
const constantRoutes = [
  {
    path: '/',
    component: () => import('../components/Home.vue')
  },
  ...Web,
  {
    name: 'login',
    path: '/login',
    component: () => import('../components/Login.vue')
  },
  {
    name: 'reg',
    path: '/reg',
    component: () => import('../components/Reg.vue')
  },
  {
    name: 'findCom',
    path: '/findCom',
    component: () => import('../components/FindCom.vue')
  },
  {
    name: 'forgotpwd',
    path: '/forgotpwd',
    component: () => import('../components/ForgotPwd.vue')
  },
  {
    name: 'expertLogin',
    path: '/expertLogin',
    component: () => import('../components/expertLogin.vue')
  },
  {
    name: 'pjnoticeInfo',
    path: '/pjnoticeInfo',
    component: () => import('../components/pjnoticeInfo.vue')
  },
  {
    name: 'BidToday',
    path: '/BidToday',
    component: () => import('../components/BidToday.vue')
  },
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export default router
